"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseValidationModule = void 0;
const Constants_1 = require("./utils/Constants");
class BaseValidationModule {
    constructor(moduleConfig) {
        const { entryPointAddress } = moduleConfig;
        this.entryPointAddress = entryPointAddress || Constants_1.DEFAULT_ENTRYPOINT_ADDRESS;
    }
    setEntryPointAddress(entryPointAddress) {
        this.entryPointAddress = entryPointAddress;
    }
}
exports.BaseValidationModule = BaseValidationModule;
//# sourceMappingURL=BaseValidationModule.js.map